// extracted by mini-css-extract-plugin
export var contentGrid = "_s-3";
export var divider = "_s-t";
export var emailInput = "_s-8";
export var emptyDescription = "_s-z";
export var emptyState = "_s-x";
export var emptyTitle = "_s-y";
export var fadeIn = "_s-10";
export var formCard = "_s-5";
export var formGroup = "_s-7";
export var helperText = "_s-9";
export var imagePlaceholder = "_s-n";
export var itemDetails = "_s-l";
export var itemImage = "_s-m";
export var itemInfo = "_s-p";
export var itemName = "_s-q";
export var itemPrice = "_s-s";
export var itemQuantity = "_s-r";
export var itemsList = "_s-j";
export var mainContent = "_s-4";
export var orderItem = "_s-k";
export var orderSummaryCard = "_s-i";
export var pageContainer = "_s-0";
export var pageHeader = "_s-1";
export var pageTitle = "_s-2";
export var paymentDescription = "_s-e";
export var paymentIcon = "_s-b";
export var paymentInfo = "_s-a";
export var paymentMethods = "_s-f";
export var paymentText = "_s-d";
export var placeholderText = "_s-o";
export var sectionTitle = "_s-6";
export var sidebarContent = "_s-h";
export var stripeIcon = "_s-c";
export var submitButton = "_s-g";
export var totalAmount = "_s-w";
export var totalLabel = "_s-v";
export var totalRow = "_s-u";